const ORIGIN = 'https://hiljuris.com';

export function buildCanonicalUrl(pathname, search='') {
  let p = pathname;
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);

  const params = new URLSearchParams(search);
  ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid']
    .forEach(k => params.delete(k));
  const qs = params.toString();

  return ORIGIN + p + (qs ? `?${qs}` : '');
}